import styled from 'styled-components'

import Button from '~/components/button'
import ContentBlock from '~/components/content-block'
import Icon from '~/components/icon'
import { PillV2 } from '~/components/pill'
import { color, device, font } from '~/styles/utils'

import AddressWithHighlightedFields from './address-with-highlighted-fields.component'

import type { FixedGlyphIcon } from '~/components/icon'

export const StyledButton = styled(Button)`
  &&& {
    margin: 0 auto;
  }
`

export const BoldOriginalAddress = styled(AddressWithHighlightedFields)`
  font-size: 18px;
  ${font('demi')};
  margin-bottom: 40px;

  div {
    width: 100%;
    text-align: center;
  }
`

export const SmallAddress = styled(AddressWithHighlightedFields)`
  font-size: 14px;
  margin-top: 5px;
`

export const NotValidatedPill = styled(PillV2).attrs(() => ({
  iconGlyph: 'triangle-exclamation',
}))`
  background-color: ${color('red')};
  ${font('bold')};
  color: ${({ theme }) => theme.color.text.onDark};
  margin: auto;
  padding: 5px 12px;
  text-transform: uppercase;
  height: auto;
  width: fit-content;
  font-size: 14px;

  margin-bottom: 20px;

  i {
    margin-right: 15px;
  }
`

export const StyledContentBlock = styled(ContentBlock)`
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;

  strong {
    ${font('demi')};
  }
`

export const SelectableOption = styled.button<{ selected?: boolean }>`
  ${font('base')};
  color: ${({ theme }) => theme.color.text.default};
  width: 100%;
  background-color: inherit;
  text-align: left;
  border: 1px solid ${color('coolGrey')};
  border-color: ${({ selected, theme }) => selected && theme.color.border.dark};
  padding: 20px 30px;
  cursor: pointer;
  display: flex;
  align-items: top;
  gap: 20px;
  margin-bottom: 30px;
`

export const TickIcon: FixedGlyphIcon<{ $dark: boolean }> = styled(Icon).attrs(
  () => ({
    glyph: 'check',
  }),
)<{ $dark: boolean }>`
  margin-top: 1px;
  font-size: 14px;
  color: ${({ $dark, theme }) =>
    $dark ? theme.color.text.default : color('coolGrey')};
`

export const SelectableOptionTitle = styled.h2`
  margin: 0;
  line-height: 1;
`

export const Content = styled.div`
  padding: 30px 20px 10px;
  height: calc(100vh - 203px);
  overflow: auto;

  @media ${device('notMobile')} {
    height: 100%;
    max-height: 450px;
    padding: 40px 60px;
  }
`
